import mapDrawGeofences from '@/views/modules/maps/mapDrawGeofences'
import { ref, toRef } from '@vue/composition-api'

L.Control.Search = L.Control.extend({
  options: {
    // topright, topleft, bottomleft, bottomright
    position: 'topright',
    placeholder: 'Search...'
  },
  initialize: function (options /*{ data: {...}  }*/) {
    // constructor
    L.Util.setOptions(this, options);
  },
  onAdd: function (map) {

    this.draw = mapDrawGeofences(ref(map))

    // happens after added to map
    var container = L.DomUtil.create('div', 'search-container');
    this.form = L.DomUtil.create('form', 'form', container);
    var group = L.DomUtil.create('div', 'form-group', this.form);
    this.input = L.DomUtil.create('input', 'form-control input-sm', group);
    this.input.type = 'text';
    this.input.placeholder = this.options.placeholder;
    this.results = L.DomUtil.create('div', 'list-group', group);
    L.DomEvent.addListener(this.input, 'keyup', this.keyup, this);
    // L.DomEvent.addListener(this.form, 'submit', this.submit, this);
    // L.DomEvent.disableClickPropagation(container);
    return container;
  },
  onRemove: function (map) {
    // when removed
    // L.DomEvent.removeListener(this._input, 'keyup', this.keyup, this);
    // L.DomEvent.removeListener(form, 'submit', this.submit, this);
  },
  keyup: function(e) {
    if (e.keyCode === 38 || e.keyCode === 40) {
    //   // do nothing
    } else {
      this.results.innerHTML = ''
      if (this.input.value.length > 2) {

        const value = this.input.value
        const res = this.options.data.value.filter(area => area.name === value)

        // console.log(res)

        if (res.length > 0) {

          console.log(res[0])
          this.draw.drawArea(res[0])
        }
        //
        // console.log(this.draw)
        // console.log(res)
      }
    }
  },

  submit: function(e) {
    L.DomEvent.preventDefault(e);
  }
});

L.control.search = function(id, options) {
  return new L.Control.Search(id, options);
}
